<div class="container">
  <div class="card">
    <div class="card-body">
      <div class="panel panel-primary">
        <div class="panel-heading custom-panel">
          <div class="titulo-painel">
            <h2>{{ tituloDaEtapaAtual }}</h2>
          </div>
        </div>
      </div>

      <div>
        <div>
          <mat-divider fxFlex="1 0"></mat-divider>
        </div>
        <div
          *ngIf="usuarioLogado.username"
          class="text-danger"
          style="margin-top: 5px; margin-bottom: 5px"
        >
          Atendente Logado: {{ usuarioLogado.username }}
        </div>
        <form
          [formGroup]="formularioDeSelecaoDePaciente"
          (ngSubmit)="onSubmit()"
          (keydown.enter)="$event.preventDefault()"
        >
          <div class="form-group">
            <mat-divider fxFlex="1 0"></mat-divider>
          </div>
          <div class="panel-heading custom-sub-panel">
            <div class="titulo-sub-painel">
              <h3>Seleção do Paciente</h3>
            </div>
          </div>
          <div class="form-row" style="margin-top: 10px">
            <div class="form-group col-md-12">
              <mat-form-field appearance="fill" class="col-md-12">
                <mat-label>Selecione o Paciente</mat-label>
                <mat-select
                  formControlName="pacienteOuDepentende"
                  name="pacienteOuDepentende"
                  (selectionChange)="onChangePacienteSelecionado()"
                >
                  <mat-option
                    *ngFor="
                      let pacienteOuDepentende of listaDePacienteESeusDependentes
                    "
                    [value]="pacienteOuDepentende"
                  >
                    {{ pacienteOuDepentende.nome }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="
                    formularioDeSelecaoDePaciente.controls.pacienteOuDepentende.hasError(
                      'required'
                    )
                  "
                >
                  O campo Paciente é obrigatório.
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-12" style="margin-bottom: 0px">
              <mat-form-field appearance="fill" class="col-md-12">
                <mat-label>Selecione {{ getPlanoOuFilial(true) }}</mat-label>
                <mat-select
                  formControlName="planoSaude"
                  name="planoSaude"
                  (selectionChange)="onChangePlanoSaude($event)"
                >
                  <mat-option
                    *ngFor="let planoSaude of listaDePlanosDeSaude"
                    [value]="planoSaude"
                  >
                    {{ planoSaude.nome }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="
                    formularioDeSelecaoDePaciente.controls.planoSaude.hasError(
                      'required'
                    )
                  "
                >
                  O campo {{ getPlanoOuFilial(false) }} é obrigatório.
                </mat-error>
              </mat-form-field>
            </div>
            <div
              class="form-group col-md-12"
              style="padding-left: 25px; padding-right: 20px"
            >
              <mat-label class="observacao-para-o-paciente">
                {{ observacaoPlanoSaude }}
              </mat-label>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-12">
              <mat-checkbox
                formControlName="portadorDeNecessidadeEspecial"
                name="portadorDeNecessidadeEspecial"
                style="padding-left: 15px"
              >
                Portador de Necessidade Especial?
              </mat-checkbox>
            </div>
          </div>

          <div class="form-row" style="margin-left: 10px; margin-right: 10px">
            <div
              class="form-group botao-marcacao-esquerda col-12 col-sm-6 col-md-6 col-lg-6"
            >
              <button
                type="button"
                (click)="telaAnterior()"
                mat-raised-button
                color="warn"
                matTooltip="Tela Anterior"
                style="margin-bottom: 10px"
                class="mat-button-marcacao"
              >
                <mat-icon>arrow_left</mat-icon>
                Tela Anterior
              </button>
            </div>
            <div
              class="form-group botao-marcacao-direita col-12 col-sm-6 col-md-6 col-lg-6"
            >
              <button
                mat-raised-button
                color="primary"
                type="submit"
                matTooltip="Continuar Marcação"
                [disabled]="!formularioDeSelecaoDePaciente.valid"
                class="mat-button-marcacao"
              >
                Continuar Marcação
                <mat-icon>arrow_right</mat-icon>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
